import { useEffect } from "react";
import { LanguageProvider } from "@/i18n/context";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Hero } from "@/sections/Hero";
import { About } from "@/sections/About";
import { Services } from "@/sections/Services";
import { Method } from "@/sections/Method";
import { Locations } from "@/sections/Locations";
import { Contact } from "@/sections/Contact";

export function App() {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLElement>("[data-reveal]");
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            (e.target as HTMLElement).dataset.reveal = "visible";
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <LanguageProvider>
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <Method />
        <Locations />
        <Contact />
      </main>
      <Footer />
    </LanguageProvider>
  );
}

export default App;
